import { render, staticRenderFns } from "./NodeLink.vue?vue&type=template&id=b56d307c&scoped=true&"
import script from "./NodeLink.vue?vue&type=script&lang=js&"
export * from "./NodeLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56d307c",
  null
  
)

export default component.exports